import * as z from 'zod';
import { Link } from 'react-router-dom';

import { Button } from '@/components/Elements';
import { Form, InputField } from '@/components/Form';
import { useAuth } from '@/lib/auth';
import GoogleLogo from '@/assets/google-logo.png';
import { useGoogleLogin } from '@react-oauth/google';
import { useNotificationStore } from '@/stores/notifications';

const schema = z.object({
  email: z.string().min(1, 'Required'),
  password: z.string().min(1, 'Required'),
});

export const LoginForm = ({ onSuccess: onLoginSuccess }) => {
  const { gLogin, login } = useAuth();

  const { addNotification } = useNotificationStore();

  const googLogin = useGoogleLogin({
    onSuccess: async (credentialResponse) => {
      await gLogin({
        access_token: credentialResponse.access_token,
      });
      onLoginSuccess();
    },
    onError: () => {
      addNotification({
        type: 'error',
        title: 'Something went wrong while logging in with Google',
      });
    },
  });

  return (
    <div>
      <Form
        className="space-y-4"
        onSubmit={async (values) => {
          await login({
            username: values.email,
            password: values.password,
          });
          onLoginSuccess();
        }}
        schema={schema}
      >
        {({ register, formState }) => (
          <>
            <InputField
              type="email"
              label="Email"
              labelTextClassName="flex flex-col gap-2"
              className="rounded-xl"
              placeholder="email@company.com"
              error={formState.errors['email']}
              registration={register('email')}
            />
            <div className="flex flex-col gap-2">
              <InputField
                type="password"
                label="Password"
                labelTextClassName="flex flex-col gap-2"
                className="rounded-xl"
                placeholder="●●●●●●●●●●●●●●"
                error={formState.errors['password']}
                registration={register('password')}
              />
              <div className="flex items-center justify-end">
                <div className="text-xs">
                  <Link
                    to="../forgot-password"
                    style={{ lineHeight: '19px', textDecoration: 'none' }}
                    className="font-medium text-brand-ai-100 hover:text-brand-ai-100 mb-5 cursor-pointer"
                  >
                    Forgot password?
                  </Link>
                </div>
              </div>
            </div>
            <div className="mt-8">
              <Button
                // isLoading={isLoggingIn}
                type="submit"
                className="w-full rounded-lg bg-brand-ai-100 btn-style  text-sm font-medium"
              >
                Login
              </Button>
            </div>
          </>
        )}
      </Form>
      <div className="flex flex-col items-center">
        <span className="my-2">or</span>
        <button
          onClick={() => {
            googLogin();
          }}
          className="w-full flex items-center rounded-lg text-sm font-medium justify-center btn-style py-2 border border-pv-primary-primary-500"
        >
          <img src={GoogleLogo} alt="" width="20" className="ml-0.5" />
          <span className="ml-2">Continue with Google</span>
        </button>
      </div>
    </div>
  );
};
